module.exports = __webpack_public_path__ + "static/pic01-8b828cb08b791f1170af3dda9534b0fd.jpg";